module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-error-404"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-home fa-lg"
  }), _vm._v(" voltar para a Home\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron text-center"
  }, [_c('div', [_c('h3', [_vm._v("Ops! Página não encontrada.")]), _vm._v(" "), _c('h1', [_vm._v("404")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('strong', {
    staticClass: "brand"
  }, [_vm._v("loca"), _c('span', [_vm._v(".")]), _vm._v("shop")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d69edaf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errors/Page404.vue
// module id = 861
// module chunks = 26